import { useState } from 'react'
import {
  AppLayout,
  Mtds,
  PlusIcon,
  ScreenHeader,
  ScreenLayout,
  TopBar,
  useGetLabsQuery
} from 'prove-common'
import { AppLogo } from '../components/app-logo/AppLogo'
import { SideBarLayout } from '../components/side-bar-layout/SideBarLayout'
import { LabForm } from '../components/reference-data/ReferenceEntityForms'
import { LabsTable } from '../tables/labs-table/LabsTable'
import { ReferenceQueryStatus } from '../components/reference-data/ReferenceQueryStatus'

export const LabsScreen = () => {
  const [creating, setCreating] = useState(false)
  const { data, isFetching, isError, refetch } = useGetLabsQuery()
  return (
    <AppLayout
      useMobileBar={false}
      isFullWidth
      sidebar={<SideBarLayout />}
      topBar={<TopBar logo={<AppLogo />} title='Laboratorier' />}
    >
      <ScreenLayout
        header={
          <ScreenHeader
            title='Laboratorier'
            description='Laboratorier som analyserer prøver. Åpne et laboratorium for å se grunnopplysninger og administrere mottaksadresser.'
            actions={
              <Mtds.Button
                data-variant='primary'
                onClick={() => setCreating(true)}
              >
                <PlusIcon />
                Legg til laboratorium
              </Mtds.Button>
            }
          />
        }
      >
        <ReferenceQueryStatus
          hasData={data != null}
          isFetching={isFetching}
          isError={isError}
          refetch={refetch}
        />
        {data ? <LabsTable labs={data} /> : null}
      </ScreenLayout>
      {creating && <LabForm onClose={() => setCreating(false)} />}
    </AppLayout>
  )
}
